import { Box, Grid, Heading, Link, Text, useMediaQuery } from '@chakra-ui/react';
import React from 'react';

const Speakers = ({ speakers, title = "Speakers" }) => {
    const [isSmallScreen] = useMediaQuery('(max-width: 768px)');

    return (
        <>
            {speakers && speakers.length > 0 && (
                <Box
                    backgroundColor="rgb(238, 238, 249)"
                    padding="29px 36px"
                    margin="32px auto 40px auto"
                >
                    <Heading
                        as="h2"
                        fontFamily="TWK Everett"
                        fontSize="24px"
                        fontWeight="400"
                        lineHeight="36px"
                    >
                        {title}
                    </Heading>
                    <Grid
                        templateColumns={isSmallScreen ? "repeat(1, 1fr)" : "repeat(2, 1fr)"}
                        width="fit-content"
                        margin="auto"
                    >
                        {speakers.map((speaker) => (
                            <Box
                                key={speaker.id}
                                display="grid"
                                gridTemplateColumns="1fr 4fr"
                                columnGap="16px"
                                justifyItems="left"
                                width="100%"
                                fontFamily="TWK Everett"
                                fontSize="20px"
                                fontWeight="400"
                                lineHeight="28px"
                                margin="1rem auto"
                            >
                                {speaker.image && speaker.image.length > 0 ? (
                                    <Box
                                        width="94px"
                                        height="94px"
                                        backgroundImage={`url(${speaker.image[0].url})`}
                                        backgroundSize="cover"
                                        backgroundPosition="center"
                                        justifySelf="flex-end"
                                    />
                                ) : (
                                    <Text marginRight={3}>Image Null</Text>
                                )}
                                <Box>
                                    <Link
                                        href={`/${speaker.uri}`}
                                        color="#6863F2"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="flex-start"
                                        _hover={{ textDecoration: 'underline' }}
                                    >
                                        {speaker.speakerFirstName} {speaker.speakerLastName}
                                    </Link>
                                    <Text fontSize="1rem" lineHeight="24px" margin="8px auto">
                                        {speaker.role}
                                    </Text>
                                    <Text fontSize="1rem" lineHeight="24px">
                                        {speaker.company}
                                    </Text>
                                </Box>
                            </Box>
                        ))}
                    </Grid>
                </Box>
            )}
        </>
    );
}

export default Speakers;
